
import { Component, Vue } from 'vue-property-decorator';
import PageTitle from '@/UI/components/common/PageTitle.vue';
import BaseDataForm from '@/UI/components/Helpers/BaseForm/BaseDataForm.vue';
import FormGroup from "@/UI/components/common/form/FormGroup.vue";
import PaymentSettingsForm from "@/form/Settings/finances/payment";
import {CashboxStore} from "@/store/modules/Finance/Cashbox";
import {CashboxSettingsStore} from "@/store/modules/Finance/CashboxSettings"
import { checkUserRole, getUserData } from '@/router/Lib/helper';
import {ICashbox, ICashboxResponseType} from "@/entity/finance/cashbox/cashbox.types";


@Component({
  components: {
        PageTitle,FormGroup
  }
})
export default class Payment extends Vue {
    form = new PaymentSettingsForm();
    checkRole: boolean = false;

    async saveSettings(): Promise<void> {
      await this.form.submit(CashboxSettingsStore.create)
    }

    get cashBoxes(): ICashbox | null{
        return CashboxStore.items;
    }

    async created(): Promise<void> {
      const Role = checkUserRole();
      const UserData = getUserData();

      this.checkRole = Vue.auth.check('owner');
      let filter = {
        limit: 20,
        filter: {}
      };

      if(Role == 'owner' && UserData && UserData.studios)
      {
        filter.filter = {'salon_id': UserData.studios}
      } else if(this.$store.state.salon_id) {
        filter.filter = {'salon_id': this.$store.state.salon_id}
      }

      await CashboxStore.fetchAll(filter);
    }
}
